import { Camera, ExternalLink, Heart, Grid3X3 } from "lucide-react";

const INSTAGRAM_URL = "https://www.instagram.com/yucca_delivery/";
const LOGO_URL = "https://customer-assets.emergentagent.com/job_ed0fd02f-a8ad-42e0-9e70-4989bc5e7fcd/artifacts/unyux3oi_IMG_4029.PNG";

const PREVIEW_IMAGES = [
  "https://customer-assets.emergentagent.com/job_flower-delivery-tr/artifacts/bqt1lqp3_IMG_9155.JPG",
  "https://customer-assets.emergentagent.com/job_flower-delivery-tr/artifacts/qrnjomfh_Untitled%20design%20%2812%29.png",
  "https://customer-assets.emergentagent.com/job_flower-delivery-tr/artifacts/oa7gii38_IMG_9152.JPG",
  "https://customer-assets.emergentagent.com/job_flower-delivery-tr/artifacts/08who7br_Untitled%20design%20%2816%29.png",
  "https://customer-assets.emergentagent.com/job_flower-delivery-tr/artifacts/lz28pw24_Untitled%20design%20%2813%29.png",
  "https://customer-assets.emergentagent.com/job_flower-delivery-tr/artifacts/7r76nv7c_IMG_9144.JPG",
];

export default function InstagramWidget({ lang = "ru" }) {
  const text = lang === "tr" ? {
    follow: "Takip Et",
    posts: "gonderi",
    desc: "Taze buketler, arkaplan hikayeleri ve ilham",
  } : lang === "en" ? {
    follow: "Follow",
    posts: "posts",
    desc: "Fresh bouquets, behind-the-scenes & inspiration",
  } : {
    follow: "Подписаться",
    posts: "публикаций",
    desc: "Свежие букеты, закулисье и вдохновение",
  };

  return (
    <section className="py-6 sm:py-8" data-testid="instagram-widget">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <a
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="block bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden hover:shadow-md transition-shadow group"
          data-testid="instagram-link"
        >
          {/* Header - profile info */}
          <div className="flex items-center gap-3 p-4 sm:p-5">
            <div className="w-11 h-11 rounded-full bg-gradient-to-br from-[#f09433] via-[#e6683c] via-[#dc2743] via-[#cc2366] to-[#bc1888] p-[2px] shrink-0">
              <div className="w-full h-full rounded-full bg-white overflow-hidden">
                <img src={LOGO_URL} alt="YUCCA Flowers" className="w-full h-full object-contain" />
              </div>
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-1.5">
                <span className="font-semibold text-sm text-gray-900 truncate">yucca_delivery</span>
                <svg viewBox="0 0 24 24" className="w-4 h-4 text-[#3897f0] shrink-0" fill="currentColor">
                  <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm-1.5 14.5l-4-4 1.4-1.4 2.6 2.6 5.6-5.6 1.4 1.4-7 7z"/>
                </svg>
              </div>
              <p className="text-xs text-gray-500 truncate">{text.desc}</p>
            </div>
            <span className="text-xs font-semibold text-white bg-[#0095f6] hover:bg-[#1877f2] px-4 py-1.5 rounded-lg shrink-0 group-hover:scale-105 transition-transform">
              {text.follow}
            </span>
          </div>

          {/* Photo grid */}
          <div className="grid grid-cols-3 sm:grid-cols-6 gap-[1px] bg-gray-100">
            {PREVIEW_IMAGES.map((src, i) => (
              <div key={i} className="aspect-square overflow-hidden relative">
                <img
                  src={src}
                  alt={`YUCCA Flowers Instagram ${i + 1}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                {i === 5 && (
                  <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                    <Grid3X3 className="w-5 h-5 text-white" />
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Stats bar */}
          <div className="flex items-center justify-between px-4 sm:px-5 py-3 border-t border-gray-100">
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-1 text-gray-500">
                <Heart className="w-3.5 h-3.5" />
                <span className="text-xs">2.4K</span>
              </div>
              <div className="flex items-center gap-1 text-gray-500">
                <Camera className="w-3.5 h-3.5" />
                <span className="text-xs">100+ {text.posts}</span>
              </div>
            </div>
            <div className="flex items-center gap-1 text-xs text-gray-400 group-hover:text-[#0095f6] transition-colors">
              <span>instagram.com</span>
              <ExternalLink className="w-3 h-3" />
            </div>
          </div>
        </a>
      </div>
    </section>
  );
}
